/*
 * @Description: 枚举数据
 * @Author: mdb
 * @Date: 2022-10-27 10:25:30
 * @LastEditTime: 2023-04-21 10:55:50
 * @LastEditors: mdb
 */
import { ref } from 'vue'
import { listByParamCodes, adminArea } from '@/api/common'
import { parentLabelList } from '@/api/marketing/marketingManage'
import { paramCodesDataFilter } from '@/utils/index'
import { paramCodesEnum } from '../common'
import type { ParamCodeItem } from '@/typings/common'

/**
 * 获取标签
 */
const tagListEnum = ref<any[]>([])
const getTagList = () => {
  return new Promise((resolve) => {
    parentLabelList().then(({ data }) => {
      tagListEnum.value = data
      resolve(data)
    })
  })
}

/**
 * 获取业务参数
 */
const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  // zbu_product_type: [], // 产品货型
  // zbu_channel_detail: [], // 销售平台
  // zbu_demand_info: [], // 需求海外仓
  // zbu_monthly_sales: [], // 跨境月销售额
  // zbu_service_demand: [], // 服务需求
  // zbu_existing_cooperation: [] // 是否已有合作
})
const lock = ref(false)
const getByParamCodes = (subdomain: 'fbu' | 'lbu' | 'ofbu') => {
  if (lock.value) return Promise.resolve(paramCodeData.value)
  return new Promise((resolve) => {
    listByParamCodes({
      appId: subdomain === 'ofbu' ? 'cos_ofbu' : 'cos_zbu',
      paramCodes: Object.values(paramCodesEnum[subdomain])
    }).then((res) => {
      lock.value = true
      setTimeout(() => {
        lock.value = false
      }, 100)
      res.data = paramCodesDataFilter(res.data, 0)
      paramCodeData.value = res.data
      resolve(res.data)
    })
  })
}

/**
 * 获取客户办公地
 */
const adminAreaEnum = ref<any[]>([])
const getAdminAreaList = () => {
  return new Promise((resolve) => {
    adminArea({ appId: 'cos_zbu' }).then(({ data }) => {
      adminAreaEnum.value = data
      resolve(data)
    })
  })
}

export function useEnum() {
  return { tagListEnum, getTagList, paramCodeData, getByParamCodes, adminAreaEnum, getAdminAreaList }
}
